import axios, { CancelToken } from 'axios';
import store from '../store';

const isFunction = (item) => typeof item === 'function';

let source = CancelToken.source();

const apiUrl = process.env.REACT_APP_API_DOMAIN ?
  !process.env.REACT_APP_API_DOMAIN.startsWith('http') ?
    `https://${process.env.REACT_APP_API_DOMAIN}` :
    process.env.REACT_APP_API_DOMAIN
  : null;
  
const defaultHeaders = (method, type = 'json') => {
  const { authToken } = store.getState().auth;

  const headers = {};
  if (method !== 'GET') headers['Content-Type'] = 'application/json';
  if (authToken) headers.Authorization = `Bearer ${authToken}`;
  if (type === 'formdata') headers['Content-Type'] = 'multipart/formdata';

  return headers;
};

const generateEndpoint = (endpoint) => `${apiUrl}${endpoint}`;

export const generateUrlParams = params => {
  if (!params) return '';

  return Object
    .keys(params)
    .reduce((acc, key) => {
      if (params[key] === null || typeof params[key] === 'undefined') {
        return acc;
      }
      if (params[key] instanceof Array) {
        return `${acc}${key}=${params[key].join(',').replace(/\s/gi, '%20')}&`;
      }
      if (params[key] instanceof Object) {
        return `${acc}${Object.keys(params[key]).reduce((acc2, paramKey) => {
          if (
            params[key][paramKey] === null ||
            typeof params[key][paramKey] === 'undefined'
          ) {
            return acc2;
          }

          return `${acc2}${key}[${paramKey}]=${params[key][paramKey]
            .join(',')
            .replace(/\s/gi, '%20')}&`;
        }, '')}&`.slice(0, -1);
      }
      if (typeof params[key] === 'string') {
        return `${acc}${key}=${params[key].replace(/\s/gi, '%20')}&`;
      }

      return `${acc}${key}=${params[key]}&`;
    }, '?')
    .slice(0, -1);
};

export const cancelAllRequests = () => {
  source.cancel();

  source = CancelToken.source();
};

const callApi = async ({
  endpoint,
  method,
  body,
  headers,
  options = {
    timeout: 30 * 1000,
  },
  type,
  callbacks,
}) => {
  const { timeout } = options;
  const computedHeaders = {
    ...defaultHeaders(method, type),
    ...headers,
  };

  let response;
  let error;
  try {
    const res = await axios({
      method,
      url: generateEndpoint(endpoint),
      headers: computedHeaders,
      data: body,
      timeout,
      cancelToken: source.token,
    });

    const init = {
      status: res.status,
      statusText: res.statusText,
      headers: res.headers,
    };

    response = new Response(JSON.stringify(res.data), init)

    if (isFunction(callbacks?.onSuccess)) {
      callbacks.onSuccess(response);
    }
  } catch (err) {
    error = err;
    if ((err.code && err.code === 'ECONNABORTED') || axios.isCancel(err))
      return new Response(
        JSON.stringify({
          aborted: true,
        }),
        {
          status: err.response.status || 500,
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

    if (isFunction(callbacks?.onFail)) {
      callbacks.onFail(err);
    }
  }

  if (isFunction(callbacks?.onComplete)) {
    callbacks.onComplete();
  }

  if (error) throw error;

  return response;
};

export default callApi;
